import { render, staticRenderFns } from "./achievements.vue?vue&type=template&id=0e0bb220"
import script from "./achievements.vue?vue&type=script&lang=js"
export * from "./achievements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports